module.exports = __webpack_public_path__ + "img/thumbnail_Ocelot_f_normal.a1ec9330.png";